import React, { useCallback, useEffect, useState } from 'react'
import { Accordion, Col, Row, Spinner } from 'react-bootstrap'
import CardOption from '../CardOption'
import Paginator from './Paginator'
import { MODEL_VIEWER_HOST } from '../../../constants/constants'

const DynamicAccordionItem = (props) => {
  const {
    optionCat,
    accordionHeader,
    idx,
    flashesContainerClass,
    activeIndex,
    listData,
    step,
    basketState,
    setBasketState,
    formState,
    setFormState,
    modelLoaded
  } = props

  const { pleatToTheStripe, flashesMatchKilt, kiltTartan } = formState

  const [options, setOptions] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [pagination, setpagination] = useState()

  const handleMaterialSelected = useCallback((payload) => {
    // ensure call back is for the correct material list
    // this may capture material updates from other lists
    // payload.materialList[0].materialListId === optionCat.dynamicOptions.materialListId
    if (!loaded && payload.materialList[0].materialListId === optionCat.dynamicOptions.materialListId) {
      const loadedOptions = payload.materialList.map(material => {
        return {
          materialListId: material.materialListId,
          materialId: material.id,
          img: material.src,
          title: material.name,
          optionName: "strap",
          optionValue: material.id,
          price: material.custom?.price
        }
      })

      const cardOptions = loadedOptions.map(option => {
        return (
          <CardOption
            keyV={`${option.optionName}- ${option.materialId}`}
            step={step}
            basketState={basketState}
            setBasketState={setBasketState}
            materialListId={option.materialListId}
            option={option}
            formState={formState}
            setFormState={setFormState}
            pleatToTheStripe={pleatToTheStripe}
            flashesMatchKilt={flashesMatchKilt}
            kiltTartan={kiltTartan}
            selected={option.optionValue === formState[option.optionName]}
          />
        )
      })

      const { currentPage, pageSize, totalItems } = payload
      setpagination(pageSize < totalItems ? { currentPage, pageSize, totalItems } : null)

      setOptions(cardOptions)
      setLoaded(true)
    }

  }, [basketState, flashesMatchKilt, formState, kiltTartan, loaded, pleatToTheStripe, setBasketState, setFormState, step])

  const handleOnMessage = useCallback((event) => {
    // console.log('event message', event)
    if (event.origin === MODEL_VIEWER_HOST
      || event.origin === 'https://kilt-configurator.web.app') {
      const { action, payload } = event.data
      switch (action) {
        case 'GET_MATERIAL_LIST_RESPONSE':
          handleMaterialSelected(payload)
          break;
        default:
          break;
      }
    }
  }, [handleMaterialSelected])

  useEffect(() => {
    if (listData[activeIndex].id === optionCat.stepId && !loaded && modelLoaded) {
      window.addEventListener('message', (event) => handleOnMessage(event))
      const frame = document.getElementById('modelFrame')
      const action = { action: 'GET_MATERIAL_LIST', payload: { ...optionCat.dynamicOptions.pagination, id: optionCat.dynamicOptions.materialListId } }
      frame.contentWindow.postMessage(action, MODEL_VIEWER_HOST)
    }

    return () => {
      window.removeEventListener('message', handleOnMessage)
    }

  }, [modelLoaded, activeIndex, handleOnMessage, listData, loaded, optionCat.dynamicOptions.materialListId, optionCat.dynamicOptions.pagination, optionCat.stepId])


  const handlePageClick = (pageNo) => {
    const frame = document.getElementById('modelFrame')
    let newPagination = optionCat.dynamicOptions.pagination
    newPagination.page = pageNo
    const action = { action: 'GET_MATERIAL_LIST', payload: { ...newPagination, id: optionCat.dynamicOptions.materialListId } }
    frame.contentWindow.postMessage(action, MODEL_VIEWER_HOST)
  }

  return (
    <Accordion.Item style={{ minHeight: '50%' }} key={'accordion-' + optionCat.optionName} eventKey={idx} className={`${flashesContainerClass} border-0 rouded-0`} >
      <Accordion.Header as={accordionHeader} className='border-0 rounded-0 bg-white' text={optionCat.title}>{optionCat.title}</Accordion.Header>
      <Accordion.Body className='px-0'>
        <Row xs={4} className="g-2" style={{ minHeight: '50%' }} >
          {loaded ? options : loader}
        </Row>
        <Row className={!pagination ? 'd-none' : ''}>
          <Col>
            <Paginator {...pagination} handlePageClick={handlePageClick} />
          </Col>
        </Row>
      </Accordion.Body>
    </Accordion.Item>
  )
}


const loader = (
  <Col
    style={{ height: '150px' }}
    className=" w-100 text-center d-flex justify-content-center align-items-center"
  >
    <Spinner
      animation="border"
    />
  </Col>
)

export default DynamicAccordionItem 